 import how_works_1 from '../../../assets/images/how_works_1.png';
// import how_works_2 from '../../../assets/images/basketball_banner_2.png';
// import how_works_3 from '../../../assets/images/how_works_3.png';
// import how_works_4 from '../../../assets/images/basketball_banner_3.png';
// import how_works_football_1 from '../../../assets/images/how_works_football_1.png';
// import how_works_football_2 from '../../../assets/images/how_works_football_2.webp';
// import how_works_football_3 from '../../../assets/images/how_works_football_3.webp';
// import how_works_football_4 from '../../../assets/images/how_works_football_4.webp';
// import how_works_football_5 from '../../../assets/images/fb-homepage.png';
import { COURT_NAME } from '../../../lib/constants/globalConstant';
// import georgia10 from '../../../assets/images/georgia10.webp';
// import georgia11 from '../../../assets/images/goergia11.webp';
// import georgia5 from '../../../assets/images/georgia5.webp';
// import georgia7 from '../../../assets/images/georgia7.webp';
import smu_2 from '../../../assets/images/smu6.png';
import smu_3 from '../../../assets/images/smu8.png';
import smu_4 from '../../../assets/images/smu7.png';


const howItWorksData = [
    {
        id: 1,
        heading: "CHOOSE A ZONE",
        description: `The digital replica of ${COURT_NAME} has been divided into 16 zones, with each zone earning unique point multipliers and rewards.`,
        image: how_works_1,
    },
    {
        id: 2,
        heading: "SELECT YOUR TOKENS",
        description: "Select one or more tokens in each zone - your points are aggregated across all tokens, so the more tokens you buy, the more points you earn.",
        image: smu_2,
    },
    {
        id: 3,
        heading: "SCORE POINTS",
        description: "All plays in your zone, live polls, predictions, trivia, and fan challenges help you earn points and climb the leaderboard.",
        image: smu_3,
    },
    {
        id: 4,
        heading: "Unlock Fan Experiences",
        description: "Redeem your points for signed memorabilia, exclusive content, sideline experiences, gift cards and more.",
         image: smu_4,
    },
]

export default howItWorksData